/**
 * Phase 10 — Payment Requests API helpers + label/tint maps.
 */
import api from "./api";

export const PAYMENT_STATUS_LABEL = {
  pending: "Pending",
  paid: "Paid",
  cancelled: "Cancelled",
  expired: "Expired",
};

export const PAYMENT_STATUS_TINT = {
  pending: "bg-amber-100 text-amber-900 border-amber-300",
  paid: "bg-emerald-100 text-emerald-800 border-emerald-300",
  cancelled: "bg-slate-100 text-slate-700 border-slate-300",
  expired: "bg-slate-100 text-slate-700 border-slate-300",
};

export const PAYMENT_TYPE_LABEL = {
  full: "Full Payment",
  deposit: "Deposit",
  custom: "Custom",
};

export const DELIVERY_LABEL = {
  email: "Email",
  sms: "SMS",
  both: "Email + SMS",
};

export const formatDollars = (cents) =>
  `$${((Number(cents) || 0) / 100).toFixed(2)}`;

export async function listPaymentRequestsForSR(srId) {
  const { data } = await api.get(`/service-requests/${srId}/payment-requests`);
  return Array.isArray(data) ? data : [];
}

export async function createPaymentRequest(body) {
  const { data } = await api.post("/payment-requests", body);
  return data; // { payment_request, sms_skipped, sms_skipped_reason }
}

export async function cancelPaymentRequest(prId) {
  const { data } = await api.patch(`/payment-requests/${prId}/cancel`);
  return data;
}
